import { AxiosResponse } from 'axios'
import customAxios from './api/interceptors'

export const sendTicket = async (text:string): Promise<AxiosResponse> => customAxios.post('forms/supports', {
  text,
})
